import { Box } from "@mui/material";
import { VideoCard } from "../../components/VideoCard";
import { PageSection } from "../../components/PageSection";

// Compressed copies served from public/videos (raw files stay out of the bundle)
const videos = ["c6769", "c6772", "c6774", "c6795", "img_8318"].map((name) => ({
  name,
  src: `${process.env.PUBLIC_URL}/videos/${name}.mp4`,
  poster: `${process.env.PUBLIC_URL}/videos/${name}.jpg`,
}));

export function Videos() {
  return (
    <PageSection
      overline="Vídeos"
      title="Momentos"
      subtitle="Cada apresentação carrega energia, emoção e conexão com o público."
    >
      {/* Flex instead of grid so an incomplete last row stays centered */}
      <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: { xs: 2, md: 3 } }}>
        {videos.map(({ name, src, poster }, index) => (
          <Box
            key={name}
            sx={{
              flexBasis: { xs: "calc((100% - 16px) / 2)", md: "calc((100% - 96px) / 5)" },
              minWidth: 0,
            }}
          >
            <VideoCard src={src} poster={poster} title={`Apresentação da Groowv Electric Band ${index + 1}`} />
          </Box>
        ))}
      </Box>
    </PageSection>
  );
}
